var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.05001 30.3C7.35001 30.3 6.65001 30 6.15001 29.5C5.65001 29 5.35001 28.4 5.35001 27.7V13C5.35001 12.3 5.65001 11.6 6.15001 11.1C6.65001 10.6 7.25001 10.3 8.05001 10.3H12.05V13H8.05001V27.7H24.05V13H20.05V10.3H24.05C24.75 10.3 25.45 10.6 25.95 11.1C26.45 11.6 26.75 12.3 26.75 13V27.7C26.75 28.4 26.45 29.1 25.95 29.6C25.45 30.1 24.75 30.4 24.05 30.4H8.05001V30.3Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3,
    height: 29.3,
    fill: "white",
    transform: "translate(5.35001 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.42c4474fb0365109465e4ad8ea0228e9.svg";
export { ForwardRef as ReactComponent };